module.exports = __webpack_public_path__ + "static/media/fly0039.4a08cde4.webp";